module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYBAMAAAA46dFkAAAABGdBTUEAALGPC/xhBQAAAA9QTFRFAAAA////payzpKu0pKqzD7zVUAAAAAR0Uk5TAAFKnTZ5RNsAAAAsSURBVAjXYxBSZAADFWcBCO1iCKaFXSACjCYUCSDTMHGoOpK4cHfB3Al1NwBi6Q5b1PFeOQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/enter@2x.png
// module id = TNrS
// module chunks = 1